// extracted by mini-css-extract-plugin
module.exports = {"pcc_container":"paymentConfirmContent_pcc_container__c4tfZ","warning_image":"paymentConfirmContent_warning_image__1TTkj","close":"paymentConfirmContent_close__2NND8"};